// extracted by mini-css-extract-plugin
export default {"wrapper":"Referral_wrapper__AV7c+","container":"Referral_container__CgQ8k"};